import { render, staticRenderFns } from "./FishStep.vue?vue&type=template&id=622709fe&scoped=true&"
import script from "./FishStep.vue?vue&type=script&lang=js&"
export * from "./FishStep.vue?vue&type=script&lang=js&"
import style0 from "./FishStep.vue?vue&type=style&index=0&id=622709fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622709fe",
  null
  
)

export default component.exports